
import { Button, FormControl, InputLabel, Menu, MenuItem, Select, TextField } from '@mui/material';
import React, { useState } from 'react';
import { CgMenuRightAlt } from "react-icons/cg";
import { RiEdit2Fill } from "react-icons/ri";
import { ResourceAPI } from '../../../api/ResourceAPI';
// import unlockImg from "../../../assets/images/unlocked.png"
// import lockImg from "../../../assets/images/padlock.png"
// import { IoLockClosed } from "react-icons/io5";
// import { IoLockOpen } from "react-icons/io5";
import { AiTwotoneEye } from "react-icons/ai";
import { AiTwotoneEyeInvisible } from "react-icons/ai";
import { useDispatch } from 'react-redux';
import { calenderAction } from '../../../redux/reducer/calenderReducer';
import { Privileges } from '../../../util/PrivilegeConstants';

const CourtItem = ({ court, gameData, setRefresh, refreshFunc, startLoading, finishLoading, privileges }) => {
    const dispatch = useDispatch();
    const patchResource = async (resourceId, resourceInfo) => {
        return await ResourceAPI.patchResource(resourceId, resourceInfo)

    };

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [openEditForm, setOpenEditForm] = useState(false);
    const [courtData, setCourtData] = useState(court);

    const handleCourtData = (event) => {
        const { name, value } = event.target;
        setCourtData({ ...courtData, [name]: value });
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const updateOpenOrCloseResource = async (isOpen) => {
        try {
            startLoading("loading1");
            await ResourceAPI.postUpdateResourceIsOpen({ resourceId: court.resourceId, isOpen: isOpen });
            dispatch(calenderAction.resetCourtData())
            setRefresh(true);
        } catch (error) {
            finishLoading("loading1");
        }
    }
    const editCourtData = () => {
        //API call for update
        try {
            startLoading("loading1")
            const resourceInfo = {
                resourceName: courtData.courtName,
                gameId: courtData.gameId,
                resourceColor: courtData.courtColor
            }
            patchResource(courtData.resourceId, resourceInfo).then((response) => {
                setRefresh(true);
                setOpenEditForm(false)
                refreshFunc(false)
            })
        } catch (error) {
            finishLoading("loading1")
        }
    }

    return (
        <div className="court_details_list">
            <div className='court_details_list_details'>
                <p>{court.courtName}</p>
                <div className='court_details_list_body'>
                    {privileges?.MANAGE_COURT?.includes(Privileges.MODIFY) &&
                    <>
                    {court?.open ?
                        <AiTwotoneEye className='court_open_icon' onClick={() => updateOpenOrCloseResource(!court?.open)} />
                        :
                        <AiTwotoneEyeInvisible className='court_close_icon' onClick={() => updateOpenOrCloseResource(!court?.open)} />
                    }
                    </>}
                    {privileges?.MANAGE_COURT?.includes(Privileges.MODIFY) &&
                    <div
                        aria-controls={open ? "custom-dropdown" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                        variant="contained"
                    >
                        <CgMenuRightAlt className='court_menu_icon' />
                    </div>}
                    <Menu
                        sx={{ left: -55 }}
                        id="custom-dropdown"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            "aria-labelledby": "custom-dropdown-button",
                        }}
                    >
                        <MenuItem onClick={() => {
                            setOpenEditForm(true)
                            handleClose()
                        }}><RiEdit2Fill className='court_edit_icon' /> Edit</MenuItem>
                    </Menu>
                </div>

            </div>
            <div className={openEditForm ? 'court_details_edit_form active' : 'court_details_edit_form'}>
                <div className="court_details_add_form">
                    <FormControl size='small' sx={{
                        width: '60%', '@media (max-width:700px)': {
                            width: '100%',
                        },
                    }} className='calender-setting-select-input'>
                        <InputLabel id="demo-simple-select-label">Select Game Name</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="gameName"
                            label="Select Game Name"
                            name='gameName'
                            value={courtData.gameId || ''}
                            onChange={handleCourtData}
                        >
                            {gameData?.map((item, index) =>
                                <MenuItem key={item.gameId} value={item.gameId} > {item.gameName} </MenuItem>
                            )}

                        </Select>
                    </FormControl>

                    <TextField
                        className='calender-setting-text-input'
                        size='small'
                        onChange={handleCourtData}
                        value={courtData.courtName || ''}
                        name='courtName' color='warning'
                        variant='outlined'
                        label='Court Name' />

                    <TextField
                        className='calender-setting-text-input'
                        sx={{ width: '25%' }}
                        type='color'
                        size='small'
                        onChange={handleCourtData}
                        value={courtData.courtColor || ''}
                        name='courtColor'
                        variant='outlined'
                        label='Court Color' />
                </div>
                <div className='court_details_edit_form_save_btn'>
                    <Button onClick={editCourtData} size='small' variant='contained'>Save</Button>
                    <Button onClick={() => setOpenEditForm(false)} sx={{ width: '15%' }} size='small' variant='outlined' color='error'>Cancel</Button>
                </div>
            </div>
        </div>
    )
}

export default CourtItem